import React from "react";
import {
    ListGroup,
    ListGroupItem,
    ButtonToolbar,
    Button,
    Glyphicon,
} from "react-bootstrap";

const LetterTemplateBlock = ({ block, className, onPreview, onDelete }) => {
    return (
        <ListGroup className={["mail-block-list", className]}>
            <ListGroupItem>
                <div className="mail-block-list-item">
                    <div className="mail-block-list-item__info">
                        <h4>{block.name}</h4>
                    </div>
                    <ButtonToolbar>
                        <Button onClick={() => onPreview(block)}>
                            <Glyphicon glyph="eye-open" />
                        </Button>
                        <Button onClick={() => onDelete(block)}>
                            <Glyphicon glyph="trash" />
                        </Button>
                    </ButtonToolbar>
                </div>
            </ListGroupItem>
        </ListGroup>
    );
};

export default LetterTemplateBlock;
